// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { tabsStyles } from "@awc/App/Widgets/XTabs/XTabs";
import xScreen from "@awc/XDL/Utilities/xScreen";
import { css } from "styled-components";

tabsStyles.wrapper = {
    css: css`
        flex-wrap: wrap;
        width: 100%;
        ${({ isLoading }: any) => (isLoading ? "display: none;" : "")}
    `,
};

tabsStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${xScreen("lte", "md")} {
            gap: 16px;
        }
    `,
};

tabsStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

tabsStyles.tabsContainer = {
    cssOverrides: {
        wrapper: css`
            padding: 0;
            ${xScreen("lte", "md")} {
                gap: 16px;
            }
        `,
    },
};

tabsStyles.tabContentWrapper = {
    css: css`
        padding: 16px;
        ${({ backgroundColor }: any) =>
            backgroundColor &&
            css`
                background-color: ${backgroundColor};
            `}
    `,
};

tabsStyles.tab = {
    css: css`
        &&& {
            margin-right: 4px;
            padding: 8px 8px 8px 16px;
            min-width: 150px;
            width: 13%;
            text-align: left;
        }
    `,
};
